import FormField from './FormField';
import FormWrapper from './FormWrapper';
import AwsCredentialsSection from './AwsCredentialsSection';
import CredentialSecurityNotice from './CredentialSecurityNotice';
import type { FieldConfig } from './types';

const additionalFields: FieldConfig[] = [
    {
        name: 'datastoreId',
        label: 'Default Datastore ID (Optional)',
        type: 'text',
        placeholder: '12345678901234567890123456789012',
        extra: 'Default datastore to use for queries',
    },
];

export default function AwsHealthImagingConfigForm() {
    return (
        <FormWrapper>
            <CredentialSecurityNotice />
            <AwsCredentialsSection showSessionToken />
            {additionalFields.map(field => (
                <FormField
                    key={Array.isArray(field.name) ? field.name.join('.') : field.name}
                    config={field}
                />
            ))}
        </FormWrapper>
    );
}
